import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Form, Input, message, Modal, Popover, Radio, Row, Select } from 'antd'
import { Grid } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import moment from 'moment'
import LeftControl from '../../Components/LeftControl'
import { getAllLocomotive, getLocomotiveCloseoutReason, updateLocomotiveTicket } from '../../Services/LocomotiveServices'
import { get_site_listing } from '../../Services/employee'
import services from '../../Services'
import { ErrorMessages, showText } from '../../helpers/textValidation'
import PageHeader from '../../Components/PageHeader'
import { Colors } from '../../helpers/Colors'
import { CaretLeftOutlined, EditOutlined, HistoryOutlined } from '@ant-design/icons'
import GoBack from '../../Components/GoBackButton/GoBack'
import PageLayout from '../../Components/LayoutComponents/PageLayout'
import { Download } from '@mui/icons-material'
import { environment } from '../../environments/environment'

const PayrollTicketPage = () => {

    const { hr, payroll } = services;
    const { TextArea } = Input;
    const [Data, setData] = useState({})
    const [equipIds, setEquipIds] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [modalData, setModalData] = useState()
    const [closeComments, setCloseComments] = useState([])
    const [Location, setLocation] = useState([])
    const [attachments, setAttachments] = useState([])
    const [isAttachmentsModalOpen, setIsAttachmentsModalOpen] = useState(false)
    const [flag, setFlag] = useState(false)
    const [filter, setFilter] = useState({}); // State for filters

    const [form] = Form.useForm()
    const history = useHistory()
    const { location } = history
    const id = location?.state?.id
    useEffect(() => {
        if (location.state?.filter) {
            setFilter(location.state.filter); // Restore filter state
            form.setFieldsValue(location.state.filter); // Set form fields if necessary
        }
        getTicketById();
    }, [location.state]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
    };
    const Fields = [
        {
            name: "Requester Name",
            key: "requestedFor",
            type: "Text",
            required: false,
            show: true
        },
        {
            name: "Date Opened",
            key: "createdAt",
            type: "Text",
            required: false,
            show: true

        },
        {
            name: "Ticket Department",
            key: "department",
            type: "Text",
            required: false,
            show: true,

        },
        {
            name: "Ticket Category",
            key: "categoryName",
            type: "Text",
            required: false,
            show: true,
            edit: false
        },
        {
            name: "Source",
            key: "source",
            type: "Text",
            required: false,
            edit: false,
            comment: false
        },
        {
            name: "Ticket Comments",
            key: "creation_comment",
            type: "Text",
            required: false,
            show: true,
            edit: false
        },
        // {
        //     name: Data?.Status === "Approval-Pending" ? "Approver" : "Supervisor (Approved By)",
        //     key: Data?.Status === "Approval-Pending" ? "approved" : "supervisor",
        //     type: "Text",
        //     required: false,
        //     show: Data?.Status === "Approval-Pending" || (Data?.Status !== "Approval-Pending" && Data?.FEmployee?.terminate !== true)
        // },
        {
            name: Data?.Status === "Approval-Pending" 
                ? "Approver" 
                : Data?.Status === "Rejected" 
                ? "Supervisor (Rejected By)" 
                : "Supervisor (Approved By)",
            key: Data?.Status === "Approval-Pending" 
                ? "approved" 
                : Data?.Status === "Rejected" 
                ? "rejected" 
                : "supervisor",
            type: "Text",
            required: false,
            show: Data?.Status === "Approval-Pending" || 
                  (Data?.Status !== "Approval-Pending" && Data?.FEmployee?.terminate !== true) || 
                  Data?.Status === "Rejected"
        },
        
        {
            name: "Sender Email",
            key: "senderEmail",
            type: "Text",
            required: false,
            show: Data?.TicketSourceId === 1 ? true : false,
            edit: false,
        },
 

        {
            name: "Closeout Reason",
            key: "closeoutreason",
            type: Data?.isCompleted ? 'Text' : "dropdown",
            required: true,
            show: Data?.Status !== "Rejected",
            edit: false,
            comment: false
        },
        {
            name: "Closed By",
            key: "closeBy",
            type: "Text",
            required: false,
            show: true,
            show: Data?.isCompleted ? true : false,

            // show:Data?.closeDate,
            edit: false,
        },
        {
            name: "Closed Date",
            key: "closeDatee",
            type: "Text",
            required: false,
            show: Data?.isCompleted ? true : false,
            edit: false,
        },
        {
            name: "Close Comments",
            key: "close_comment",
            type: "Text",
            required: false,
            show: Data?.isCompleted ? true : false
        },
        
        {
            name: "Comments",
            key: "closeoutcomment",
            type: "Text",
            required: true,
            edit: false,
            show: Data?.isCompleted == false && Data?.Status !== "Rejected",
            comment: true
        },
    ]

    const getTicketById = async () => {

        const result = await payroll.fetchTicketByID({ id });
        if (result?.httpStatus != 200) return
        form.setFieldsValue({
            requestedFor: result?.data?.FEmployee?.firstName ? `${result?.data?.FEmployee?.firstName} ${result?.data?.FEmployee?.lastName}` : result?.data?.employeeName,
            requestedBy: result?.data?.BEmployee?.firstName,
            categoryName: result?.data?.TicketCategory?.name ? result?.data?.TicketCategory?.name : result?.data?.TicketCategoryText,
            department: result?.data?.TicketType?.name,
            location: result?.data?.TGSLocation?.name,
            closeBy: result?.data?.CEmployee?.firstName && result?.data?.CEmployee?.lastName 
            ? result.data.CEmployee.firstName + " " + result.data.CEmployee.lastName 
            : "N/A",
        closeDatee: result?.data?.closeDate 
            ? moment(result.data.closeDate).utc().format("MM-DD-YYYY") 
            : "N/A",

            source: showText(result?.data?.TicketSource?.name),
            closeoutreason: result?.data?.TicketClose?.CloseType,
            close_comments: result?.data?.close_comment,
            supervisor: result?.data?.Supervisor?.firstName ? `${result?.data?.Supervisor?.firstName} ${result?.data?.Supervisor?.lastName}` : 'Supervisor - NA',
            approved: result?.data?.Supervisor?.firstName ? `${result?.data?.Supervisor?.firstName} ${result?.data?.Supervisor?.lastName}` : 'Supervisor - NA',
            rejected: result?.data?.Supervisor?.firstName ? `${result?.data?.Supervisor?.firstName} ${result?.data?.Supervisor?.lastName}` : 'Supervisor - NA',

            commenthistory: result?.data?.comment,
            ...result?.data,
            ...result?.data?.EquipId,
            enteredBy: result?.data?.FEmployee ? `${result?.data?.FEmployee?.firstName} ${result?.data?.FEmployee?.lastName}` : result?.data?.employeeName,
            // enteredBy: result?.data?.BEmployee ? `${result?.data?.BEmployee?.firstName} ${result?.data?.BEmployee?.lastName}` : result?.data?.employeeName,
            id: result?.data?.id,
            createdAt: moment(result?.data?.OpenDate || result?.data?.createdAt || 'N/A')?.utc()?.format("MM-DD-YYYY  HH:mm:ss")
        })
        setData(result?.data)
        
        setAttachments(result?.attachments)
        getCloseOutComments(result?.data?.TicketTypeId)
    }
    console.log(Data,'ddd')

    const getCloseOutComments = async (id) => {

        const result = await getLocomotiveCloseoutReason(id)
        if (result?.httpStatus != 200) return
        const data = result?.data.map((item, index) =>
        ({
            label: item?.CloseType,
            value: item?.id
        }))
        setCloseComments(data)

    }

    const getSiteLocation = async () => {

        const result = await get_site_listing()
        if (result?.httpStatus != 200) return
        const data = result?.data.map((item, index) => {
            return {
                label: item?.title,
                value: item?.id
            }
        })
        setLocation(data)

    }

    const getEquipID = async () => {
        const result = await getAllLocomotive()
        if (result?.httpStatus != 200) return
        const data = result?.data.map((item, index) => {
            return {
                label: item?.EquipUID,
                value: item?.id
            }
        })
        setEquipIds(data)
    }

    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

    const dropDownDataSet = (data, flag) => {

        if (data) {
            if (flag == 'location') {
                if (Data?.TGSLocation?.name === data) {
                    return Data?.TGSLocation?.id
                } else {
                    return data
                }
            } if (flag == 'equipId') {
                if (Data?.EquipId?.EquipUID === data) {
                    return Data?.EquipId?.id
                } else {
                    return data
                }
            }
            if (flag == 'ticketcloseid') {
                if (Data?.TicketClose?.CloseType === data) {
                    return Data?.TicketClose?.id
                } else {
                    return data
                }
            }
        } else {
            return data
        }

    }

    const updateAPI = async (payload = {}) => {
        const result = await updateLocomotiveTicket(Data?.id, { ...payload, close: false })
        if (result?.httpStatus != 200) return
        form.setFieldsValue({ closeoutcomment: "" })
        message.success('Successfully Updated!')
        getTicketById()
    }

    const closeAPI = async (data = {}) => {
        const result = await payroll.closeTicket(Data?.id, data)
        if (result?.httpStatus != 200) return
        history.push('/payroll-tickets')
        message.success('Ticket Closed!')
    }

    const handleSubmit = async (values) => {
        let data = {
            TicketCloseId: dropDownDataSet(values?.closeoutreason, 'ticketcloseid'),
            close_comment: values?.closeoutcomment,
        }
        await closeAPI(data)
    }

    useEffect(() => {
        getTicketById()
    }, [openModal])

    useEffect(() => {
        getSiteLocation()
        getEquipID()
    }, [])

    const HandleModal = () => setOpenModal(!openModal)

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>

            <Grid className="PagesFrame">
                <PageHeader />
                <Grid container id="PageTitle">Payroll - Ticket/Alert </Grid>
                <Grid>
                    <Row>
                        <Col md={17}>
                            <GoBack path={"/payroll-tickets"} state={ filter }/>
                        </Col>
                        <Col>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "end", border: '2px solid black ', borderRadius: "10px", padding: "5px", marginTop: '10px' }}>
                                <div style={{ display: "flex" }}>
                                    <div style={{
                                        fontWeight: "600",
                                        whiteSpace: "nowrap",
                                        padding: "0px",
                                        margin: "0px",
                                        fontSize: "13px",
                                        display: 'flex',
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}>
                                        <p style={{ marginBottom: "0px", width: "150px" }}>ID
                                        </p>
                                    </div>

                                    <div
                                        style={{ display: "flex", alignItems: "center", margin: "0px", width: "150px" }}>
                                        <p style={{ color: "gray", flexWrap: "nowrap", marginBottom: "0px" }}>{Data?.id}</p>
                                    </div>

                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{
                                        fontWeight: "600",
                                        whiteSpace: "nowrap",
                                        padding: "0px",
                                        margin: "0px",
                                        fontSize: "13px",
                                        display: 'flex',
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}>
                                        <p style={{
                                            marginBottom: "0px", width: "150px"
                                        }}>Entered By
                                        </p>
                                    </div>

                                    <div name={"ID"}
                                        style={{ display: "flex", alignItems: "center", margin: "0px", width: "150px" }}>
                                        <p style={{ color: "gray", whiteSpace: "nowrap", marginBottom: "0px" }}>
                                            {Data?.BEmployee ? `${Data?.BEmployee?.firstName} ${Data?.BEmployee?.lastName}` : showText(Data?.employeeName)}
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </Col>
                    </Row>

                </Grid>
                <div style={{ marginTop: "10px" }}>
                    <Form style={{ marginTop: '10px', display: "flex", flexDirection: "column", gap: "10px" }}
                        name="LocomotiveForm"
                        onFinish={handleSubmit}
                        form={form}>
                        {
                            Fields.map((item, index) => (
                                <div>
                                    <div style={{ display: "flex", alignItems: "center", }}>
                                        {!item?.comment && item?.show &&
                                            <>
                                                <div style={{
                                                    fontWeight: "600",
                                                    whiteSpace: "nowrap",
                                                    padding: "0px",
                                                    margin: "0px",
                                                    fontSize: "13px"
                                                    , width: "300px",
                                                    display: 'flex',
                                                    justifyContent: "space-between",
                                                    alignItems: "center"
                                                }}>
                                                    <p style={{ marginBottom: "0px" }}>{item.name}</p>  {item?.edit && <Button onClick={() => { setModalData({ label: item, values: Data }); HandleModal(); }} style={{ background: "none", border: "none", marginBottom: "0px" }}> <EditOutlined style={{ cursor: "pointer" }} /> </Button>}
                                                </div>
                                                {
                                                    item.type !== 'dropdown' ?
                                                        <Form.Item name={item?.key} rules={[{ required: item?.required, message: ErrorMessages.requiredField }]}
                                                            style={{ display: "flex", alignItems: "center", margin: "0px" }}>

                                                            <TextArea autoSize type={item?.type} placeholder='N/A'
                                                                readOnly={true} style={{
                                                                    border: "none",
                                                                    backgroundColor: "#f6f6f6",
                                                                    fontSize: "13px",
                                                                    width: "400px",
                                                                    padding: '0px 0px 0px 0px',
                                                                }} />

                                                        </Form.Item>
                                                        :
                                                        <Form.Item name={item?.key} rules={[{ required: item?.required, message: ErrorMessages.requiredField }]}
                                                            style={{ display: "flex", alignItems: "center", margin: "0px" }}>
                                                            <Select style={{ width: "400px" }}
                                                                placeholder='Select Value.'
                                                                showSearch
                                                                optionFilterProp="children"
                                                                onChange={() => { }}
                                                                onSearch={() => { }}
                                                                filterOption={filterOption}
                                                                options={item?.key === 'location' ? Location : item?.key === "EquipUID" ? equipIds : closeComments}
                                                            />
                                                        </Form.Item>
                                                }
                                            </>
                                        }
                                    </div>
                                    {
                                        item?.comment && item?.show &&
                                        <div style={{ width: "100%", marginTop: "40px" }}>
                                            <div style={{
                                                fontWeight: "600",
                                                whiteSpace: "nowrap",
                                                padding: "0px",
                                                margin: "0px",
                                                fontSize: "15px",
                                                display: 'flex',
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}>
                                                <p style={{ marginBottom: "0px" }}>{item.name}</p>  {item?.edit &&
                                                    <Button onClick={() => { setModalData({ label: item, values: Data }); HandleModal(); }}
                                                        style={{ background: "none", border: "none", marginBottom: "0px" }}>
                                                        <EditOutlined style={{ cursor: "pointer" }} /> </Button>}
                                            </div>
                                            <Form.Item name={item?.key} rules={[{ required: item?.required, message: ErrorMessages.requiredField }]}>
                                                <TextArea rows={5} type={item?.type} placeholder='Enter Text' readOnly={false} style={{
                                                    background: 'white',
                                                    border: "none",
                                                    fontSize: "16px",
                                                    width: "600px",
                                                    borderRadius: "10px",
                                                    padding: "10px",
                                                    marginTop: "10px"
                                                }} />
                                            </Form.Item>
                                        </div>
                                    }
                                </div>

                            ))
                        }
                        <div style={{ margin: "20px 0px" }}>
                            {attachments?.length
                                ? <Button
                                    style={{ background: '#2963AD', color: 'white', marginTop: "10px", borderRadius: "5px", cursor: "pointer", border: "none", fontSize: "14px" }}
                                    onClick={() => setIsAttachmentsModalOpen(true)}
                                >Attachments
                                </Button>
                                : <Button
                                    style={{ background: '#2963AD', color: 'white', marginTop: "10px", borderRadius: "5px", cursor: "pointer", border: "none", fontSize: "14px" }}
                                    disabled={true}
                                >Attachments
                                </Button>}
                        </div>
                        { Data?.isCompleted == false && Data?.Status !== "Rejected" &&
                            <div style={{ width: "600px", display: "flex", justifyContent: "end", gap: "20px", }}>
                                {/* <Button htmlType='submit' onClick={() => setFlag(false)} style={{ background: '#2863ad', color: "white", padding: "10px 20px", height: "50px", width: "fit-content", borderRadius: "10px  " }}>Save </Button> */}
                                <Button
                                    htmlType='submit'
                                    onClick={() => setFlag(true)}
                                    style={{ background: '#2863ad', color: "white", padding: "10px", height: "50px", width: "fit-content", borderRadius: "10px  " }}>Close Ticket </Button>
                            </div>
                        }
                    </Form>
                </div>

            </Grid>
            <Modal
                footer={null}
                title="Attachments"
                open={isAttachmentsModalOpen}
                width={600}
                onCancel={() => setIsAttachmentsModalOpen(false)}
            >
                <div style={{ display: "grid", gridTemplateColumns: "50% 50%", gap: "20px" }}>
                    {attachments?.map(file => {
                        return <a href={`${environment?.apiPath}/employee/applicant/download-attachments?path=Payroll/${Data?.id}/${file}`} download>
                            <Popover content={file}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "10px 20px", background: "#ececec",
                                    borderRadius: "5px", width: "250px", color: "black"
                                }}>
                                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100px" }}>{file}</span>
                                    <Download />
                                </div>
                            </Popover>
                        </a>
                    }
                    )}
                </div>
            </Modal>

        </PageLayout>

    )
}

export default PayrollTicketPage




